var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classList},[_c('el-button',_vm._b({staticClass:"presence__control-save",attrs:{"type":_vm.type},on:{"click":function($event){return _vm.$emit('click')}}},'el-button',_vm.$attrs,false),[_vm._t("default")],2),(_vm.pulse)?_c('div',{staticClass:"v-button__rings"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }